var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4817_3692",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4817_3692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25 15.75C4.8375 15.75 4.4845 15.6033 4.191 15.3097C3.897 15.0157 3.75 14.6625 3.75 14.25V4.5C3.5375 4.5 3.35925 4.42825 3.21525 4.28475C3.07175 4.14075 3 3.9625 3 3.75C3 3.5375 3.07175 3.35925 3.21525 3.21525C3.35925 3.07175 3.5375 3 3.75 3H6.75C6.75 2.7875 6.822 2.60925 6.966 2.46525C7.1095 2.32175 7.2875 2.25 7.5 2.25H10.5C10.7125 2.25 10.8908 2.32175 11.0347 2.46525C11.1783 2.60925 11.25 2.7875 11.25 3H14.25C14.4625 3 14.6405 3.07175 14.784 3.21525C14.928 3.35925 15 3.5375 15 3.75C15 3.9625 14.928 4.14075 14.784 4.28475C14.6405 4.42825 14.4625 4.5 14.25 4.5V14.25C14.25 14.6625 14.1033 15.0157 13.8097 15.3097C13.5157 15.6033 13.1625 15.75 12.75 15.75H5.25ZM5.25 4.5V14.25H12.75V4.5H5.25ZM9 10.425L10.425 11.85C10.575 11.9875 10.7533 12.0563 10.9598 12.0563C11.1657 12.0563 11.3375 11.9875 11.475 11.85C11.625 11.7 11.7 11.5217 11.7 11.3153C11.7 11.1093 11.625 10.9375 11.475 10.8L10.05 9.375L11.475 7.95C11.625 7.8 11.7 7.62175 11.7 7.41525C11.7 7.20925 11.625 7.0375 11.475 6.9C11.3375 6.75 11.1657 6.675 10.9598 6.675C10.7533 6.675 10.575 6.75 10.425 6.9L9 8.325L7.575 6.9C7.4375 6.75 7.26575 6.675 7.05975 6.675C6.85325 6.675 6.675 6.75 6.525 6.9C6.3875 7.0375 6.31875 7.20925 6.31875 7.41525C6.31875 7.62175 6.3875 7.8 6.525 7.95L7.95 9.375L6.525 10.8C6.3875 10.9375 6.31875 11.1093 6.31875 11.3153C6.31875 11.5217 6.3875 11.7 6.525 11.85C6.675 11.9875 6.85325 12.0563 7.05975 12.0563C7.26575 12.0563 7.4375 11.9875 7.575 11.85L9 10.425Z",
    fill: "#FF3D00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.d490fb17f4a854ec58e2d60adbb7bca5.svg";
export { ForwardRef as ReactComponent };